var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 13.75C6.875 11.6875 7.49375 10.8625 8.48375 9.85875L9.72125 8.59375C10.505 7.81 11 6.71 11 5.5C11 2.46125 8.53875 0 5.5 0C2.46125 0 0 2.46125 0 5.5H2.75C2.75 3.9875 3.9875 2.75 5.5 2.75C7.0125 2.75 8.25 3.9875 8.25 5.5C8.25 6.25625 7.9475 6.94375 7.43875 7.43875L5.73375 9.17125C4.74375 10.175 4.125 11.55 4.125 13.0625V13.75H6.875ZM4.125 18.25C4.125 18.8023 4.57272 19.25 5.125 19.25H5.875C6.42728 19.25 6.875 18.8023 6.875 18.25V17.5C6.875 16.9477 6.42728 16.5 5.875 16.5H5.125C4.57272 16.5 4.125 16.9477 4.125 17.5V18.25Z",
    fill: "#482A73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.8c092f3b.svg";
export { ForwardRef as ReactComponent };